<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero" :fill="inverse ? 'black' : 'white'">
        <circle
          v-show="withCircle"
          fill-opacity="0.1"
          cx="12"
          cy="12"
          r="12"
        />
        <path d="M12,4.5 C11.1738285,4.5 10.5,5.1738285 10.5,6 C10.5,6.8261715 11.1738285,7.5 12,7.5 C12.8261715,7.5 13.5,6.8261715 13.5,6 C13.5,5.1738285 12.8261715,4.5 12,4.5 Z M12,10.5 C11.1738285,10.5 10.5,11.1738285 10.5,12 C10.5,12.8261715 11.1738285,13.5 12,13.5 C12.8261715,13.5 13.5,12.8261715 13.5,12 C13.5,11.1738285 12.8261715,10.5 12,10.5 Z M12,16.5 C11.1738285,16.5 10.5,17.1738285 10.5,18 C10.5,18.8261715 11.1738285,19.5 12,19.5 C12.8261715,19.5 13.5,18.8261715 13.5,18 C13.5,17.1738285 12.8261715,16.5 12,16.5 Z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: true,
    },
    inverse: {
      type: Boolean,
      default: false,
    },
    withCircle: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
